(function ($) {


    this.init = function () {
        this.BlogListing();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.BlogListing = function () {

        // To prevent weird screen junk, prevent default on the hover event for the Blog Card Listings
        $(".blog-listing-card").hover(function (event) {
            event.preventDefault();
            event.stopPropagation();
        })

    }

    this.init();

})(jQuery);